export type ImportState = ImportIdle | ImportStart | ImportLoading | ImportSelecting | ImportSaving;

export interface TrackImport {
    type: 'track';
    localId: string;
}

export interface AreaImport {
    type: 'area';
    localId: string;
}

export interface WaypointImport {
    type: 'waypoint';
    localId: string;
}

export type Imports = Array<TrackImport | AreaImport | WaypointImport>;

export interface ImportIdle {
    status: 'idle';
}

export interface ImportStart {
    status: 'sidebarOpen';
}

export interface ImportLoading {
    status: 'loading';
    fileNames: string[];
    files: FileList;
    eventSource: 'Drag and Drop File' | 'Click Select File';
    pendingImport?: any;
    largeImportConfirmed?: boolean;
    importTypes?: ('tracks' | 'waypoints' | 'areas')[];
}

export interface ImportSelecting {
    status: 'selecting';
    fileNames: string[];
    eventSource: 'Drag and Drop File' | 'Click Select File';
    bounds?: [number, number, number, number];
    imports?: Imports;
    popup?: SelectionState;
    error?: {
        message: string;
        detail: string;
    };
    toSave?: number;
    unsaved?: number;
    folder?: Folder;
}

export interface ImportSaving {
    status: 'saving';
    toSave: number;
    unsaved: number;
    folder?: Folder;
}

export const idle: ImportIdle = {status: 'idle'};
